// @flow
import * as types from './mutation-types'
import type { TerminateCardModuleState } from './index'
import type { CardSummary } from '../../../types/card-summary'
import type {FilterPair} from '../../../types/filter-pair'
import {buildCompanyCardsFilter} from '../../../types/company-cards-filter'

export default {
  [types.SET_SEARCH_RESULT_ITEMS_FOR_CURRENT_FILTER]: (state: TerminateCardModuleState, cards: CardSummary[]): void => {
    state.searchResultItemsForCurrentFilter = cards
  },
  [types.SET_NO_SEARCH_RESULT_ITEMS_FOR_CURRENT_FILTER]: (state: TerminateCardModuleState, count: number): void => {
    state.noSearchResultItemsForCurrentFilter = count
  },
  [types.SET_SELECTED_ITEMS]: (state: TerminateCardModuleState, cards: CardSummary[]): void => {
    state.selectedItems = cards
  },
  [types.ADD_SELECTED_ITEM]: (state: TerminateCardModuleState, card: CardSummary): void => {
    state.selectedItems.push(card)
  },
  [types.DELETE_SELECTED_ITEM]: (state: TerminateCardModuleState, card: CardSummary): void => {
    state.selectedItems = state.selectedItems.filter(storeCard => storeCard.cardId !== card.cardId)
  },
  [types.SET_CURRENT_PAGE_NUMBER]: (state: TerminateCardModuleState, { number }: { number: number }): void => {
    state.currentPageNumber = number
  },
  [types.SET_PAGE_SIZE]: (state: TerminateCardModuleState, number: number): void => {
    if (number <= 0) {
      return
    }
    state.pageSize = number
    let noPages = Math.ceil(state.noSearchResultItemsForCurrentFilter / number)
    if (state.currentPageNumber >= noPages) {
      state.currentPageNumber = noPages - 1
    }
  },
  [types.SET_ORDER_BY]: (state: TerminateCardModuleState, orderBy: ?string): void => {
    state.orderBy = orderBy
  },
  [types.SET_ORDER_DIRECTION]: (state: TerminateCardModuleState, orderDirection: ?string): void => {
    state.orderDirection = orderDirection
  },
  [types.SET_FILTER_PAIR]: (state: TerminateCardModuleState, filterPair: FilterPair): void => {
    state.filter[filterPair.key] = filterPair.value
  },
  [types.RESET_FILTER]: (state: TerminateCardModuleState): void => {
    state.filter = buildCompanyCardsFilter()
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/order-terminate-card/mutations.js